---
de:
  email:
    body:
      task_assigned: Eine neue Aufgabe wurde für %{power_plant} (%{company}) zugewiesen.
      yield_loss: 'Finanzielle Verluste:'
    data_export_error:
      body: Ihre Datenexportanfrage konnte nicht abgeschlossen werden, da Wechselkursdaten für den ausgewählten Zeitraum und die Währung fehlen.
      contact_support: Bitte kontaktieren Sie den Support für Hilfe.
      error_details: 'Fehlerdetails: %{message}'
      greeting: Hallo %{name},
    footer:
      auto_generated: Diese E-Mail wurde automatisch generiert.
      here: Hier
      kaiasolutions_staff: Personal
      notifications: Weitere Informationen auf dem  %{portal_href}.
      notifications_plain: Sie erhalten diese Benachrichtigung, weil Sie Zugang zum %{brand} haben.
      portal_href: Portal O&M Dashboard
      regards: Grüße
    heading:
      greeting: Hi
    subjects:
      data_export_error: Datenexport fehlgeschlagen
      immediate_notifications: Portal - Sofort-Benachrichtigung "%{notification_rule_name}"
      periodic_notifications: Portal - "%{notification_rule_name}"
      task_assigned: Aufgabe zugewiesen
